import styled from 'styled-components'

export const Wrap = styled('div')`
  font-size: 10px;
  color: var(--text);
  font-family: var(--regular);
  margin-left: auto;
`
